'use client';
import { createStyles, rem } from '@s7/styles';

var useStyles = createStyles((theme)=>{
    const { fn: { space }, palette } = theme;
    return {
        root: {
            borderTop: `${rem(1)} solid ${palette.border.divider}`,
            padding: '0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
            backgroundColor: theme.palette.tabsnav.background,
            backdropFilter: 'blur(20px)'
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            maxWidth: rem(770),
            margin: space('0 auto'),
            padding: space('0 1.5s')
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=TabNavigation.styles.js.map
